@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;
@use '../../../../styles/scss/vcom/mixins/breakpoints';


.vs-bubble-links-wrapper {
  position: absolute;
  top:-112px;
  right: 0;
  width: 50%;
  height: 130%;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
}

.vs-bubble-links-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 125px;
  will-change: transform;

  @include breakpoints.mobile{
    gap: 50px;
    padding: 20px;
  }
  @include breakpoints.tablet-up{
    gap: 100px;
  }
  @include breakpoints.desktop-up{
    gap: 100px;
  }
  @include breakpoints.desktop-plus-up{
    gap: 125px;
  }
}

/* Remove animation styles since we're using transform */

.vs-bubble-links-container.is-paused {
  animation-play-state: paused;
}

.vs-bubble {
  padding: 0 24px;
  border-radius: 30px;
  text-decoration: none;
  color: #2C2C2C;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  display: flex;
  align-items: center;
  width: 416px;
  pointer-events: auto;
  position: relative;
  display: flex;
  align-items: center;
  opacity: 0.95;
  @include breakpoints.mobile {
    height: 51px;
    max-width: 416px;
    min-width: 300px;
    width: calc(300px + (416 - 300) * ((100vw - 375px) / (767 - 375)));
}
  @include breakpoints.tablet-up{
  max-width: 300px;
  height: 51px;
}

  @include breakpoints.desktop-plus-up{
    max-width: 416px;
    font-size: 15px;
    height: 86px;
  }
.vs-bubble:nth-child(odd) {
  margin-left: 1%;
}

.vs-bubble:nth-child(even) {
  margin-left: 18%;
}
}


.vs-bubble.lightYellow {
  background-color:classic.$vs-lightYellow;
}

.vs-bubble.lightBlue {
  color: black !important;
  background-color:classic.$vs-lightBlue;
}

.vs-bubble.yellow {
  background-color:classic.$vs-bubble-yellow;
}

.vs-bubble:nth-child(odd) {
  align-self: flex-start;
  margin-left: 1%;
  @include breakpoints.mobile{
    margin-left: 0%;
  }
}

.vs-bubble:nth-child(even) {
  align-self: flex-start;
  margin-left: 18%;
  @include breakpoints.mobile{
    margin-left: 0%;
  }
}

@include breakpoints.desktop-plus-up {
  .vs-bubble:nth-child(odd) {
    margin-left: 13%;
  }
  .vs-bubble:nth-child(even) {
    margin-left: 27%;
  }
}

.vs-bubble:nth-child(odd) {
  @include breakpoints.mobile{
    margin-left: 6%;
  }
}

.vs-bubble:nth-child(even) {
  @include breakpoints.mobile{
    margin-left: -6%;
  }
}

.vs-bubble-links-container .vs-link-cta.vs-link-secondary {
  display: flex;
  justify-content: flex-start;
}

@keyframes streamUp {
  0% { transform: translateY(100%); }
  100% { transform: translateY(-100%); }
}

@keyframes streamDown {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(100%); }
}

.vs-bubble {
  cursor: pointer;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.03);
    opacity: 100%;
  }
}

.vs-bubble:focus{
  outline: dashed 2px classic.$vs-black !important;
  outline-offset: -3px;
  text-decoration: none;
  opacity: 100%;
}

.vs-bubble-controls {
  position: relative;
  z-index: 3;
  gap: 20px;
  justify-content: end;
  width: 50%;
  margin-left: 50%;
  @include breakpoints.tablet-up{
    position: absolute;
    padding-right: 35px;
    top:9px;
  }
  @include breakpoints.desktop-up{
    position: absolute;
    padding-right: 35px;
    top:9px;
  }
  @include breakpoints.desktop-plus-up{
    position: absolute;
    padding-right: 35px;
    top:33px;
  }
}

.vs-bubble-control-button {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  font-family: 'visa-icon', sans-serif;
  color: #5c5c5c;
}

.vs-bubble-control-button:focus-visible {
  outline: 2px solid #1434CB;
  outline-offset: 2px;
}

.vs-bubble-control-button.vs-bubble-play-pause:before {
  content: "\e944";
}

.vs-bubble-control-button.vs-bubble-play-pause.is-playing:before {
  content: "\e943";
}

.vs-bubble-control-button.bubble-up:before {
  content: "\e6f0";
}

.vs-bubble-control-button.bubble-down:before {
  content: "\e95d";
}

/* New styles for black background play/pause button */
.vs-bubble-control-button.vs-bubble-play-pause-black {
  background-color: black;
  box-shadow: 0 0 0 3px black;
  color: white;
  border: 2px solid white;

  &:hover,
  &:focus {
    background-color: #2c2c2c;
    opacity: 0.8;
  }

  &:focus {
    outline: 1px dashed white;
    outline-offset: -5px;
  }
}

/* Styles for black background up/down buttons without white circle effect */
.vs-bubble-control-button.bubble-up-black,
.vs-bubble-control-button.bubble-down-black {
  background-color: black;
  color: white;
  border: none;

  &:hover,
  &:focus {
    background-color: #2c2c2c;
    opacity: 0.8;
  }

  &:focus {
    outline: 1px dashed white;
    outline-offset: -5px;
  }
}

@include breakpoints.mobile {
  .vs-bubble-controls {
    margin-top: 20px;
    margin-bottom: 20px;
    right: 20px;
  }

  .vs-bubble-control-button {
    width: 40px;
    height: 40px;
  }
}

.vs-bubble-links-animate-up {
  animation: bubbleLinksSlideUp 0.8s ease-out 1s forwards;
  opacity: 1;
}

@keyframes bubbleLinksSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}

.vs-bubble a{
  margin:0 !important;
  color:black !important;
  font-family: var(--text-font-family);
  font-size: 15px !important;
  line-height: 21px !important;
  @include breakpoints.desktop-plus-up{
    font-family: var(--text-font-family);
    font-size: 19px !important;
    line-height: 26px !important;
  }
}

.vs-bubble-links-controller{
  overflow: hidden;
  position: relative;
  z-index: 2;
  opacity: 0;
  @include breakpoints.tablet-up{
    height: 540px;
    position:absolute;
    padding-left: 15px;
    padding-right: 30px;
    width: 100%;
    top:60px;
  }
  @include breakpoints.desktop-up{
    height: 640px;
    position:absolute;
    padding-left: 15px;
    padding-right: 30px;
    width: 100%;
    top:60px;
  }
  @include breakpoints.desktop-plus-up{
    height: 850px;
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
    top: 0;
  }
  @include breakpoints.mobile{
    height: 385px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
  }
}

.brand vs-link.vs-bubble:hover .vs-link-cta.vs-link-secondary:after {
  left: var(--link-icon-transform);
  transition: var(--link-icon-transition);
}

.vs-bubble-links-and-controller{
  @include breakpoints.mobile{
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    height: 465px;
}
}
